module.exports = __webpack_public_path__ + "img/green_glacier.092a25fc.jpg";